function autoResize(el) {
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight}px`;
}

/**
 * ダウンロードするWordファイル（出張報告書）の見た目を画面上で近似したもの。
 * shutchoExport.jsのbuildShutchoWordBlobと同じ項目に合わせてある。
 * 承認印欄（理事長／業務執行理事／施設長）は枠だけ示し、中身の編集は無し。
 * 項目・成果・その他はここで直接編集でき、onFieldChange/onResultChangeで親のstateに反映される。
 */
export default function ShutchoPreview({ fields, onFieldChange, resultText, onResultChange }) {
  return (
    <div className="word-preview-page">
      <h3 className="wp-title">出張報告書</h3>
      <table className="wp-stamp-table">
        <thead>
          <tr><th>理事長</th><th>業務執行理事</th><th>施設長</th></tr>
        </thead>
        <tbody>
          <tr><td></td><td></td><td></td></tr>
        </tbody>
      </table>

      <table className="wp-info-table">
        <tbody>
          <tr>
            <th>提出日</th>
            <td colSpan={3}>
              <input className="wp-field wp-field-cell" value={fields.submitDate} onChange={(e) => onFieldChange('submitDate', e.target.value)} />
            </td>
          </tr>
          <tr>
            <th>出張命令書日付</th>
            <td colSpan={3}>
              <input className="wp-field wp-field-cell" value={fields.orderDate} onChange={(e) => onFieldChange('orderDate', e.target.value)} />
            </td>
          </tr>
          <tr>
            <th>役職</th>
            <td><input className="wp-field wp-field-cell" value={fields.role} onChange={(e) => onFieldChange('role', e.target.value)} /></td>
            <th>氏名</th>
            <td><input className="wp-field wp-field-cell" value={fields.name} onChange={(e) => onFieldChange('name', e.target.value)} /></td>
          </tr>
        </tbody>
      </table>

      <div className="wp-item">
        <p className="wp-item-label">成果</p>
        <textarea
          className="wp-item-textarea"
          value={resultText}
          placeholder="成果がここに表示されます"
          ref={(el) => { if (el) autoResize(el); }}
          onChange={(e) => { onResultChange(e.target.value); autoResize(e.target); }}
        />
      </div>
      <div className="wp-item">
        <p className="wp-item-label">その他</p>
        <textarea
          className="wp-item-textarea"
          value={fields.other}
          placeholder="（該当なし）"
          ref={(el) => { if (el) autoResize(el); }}
          onChange={(e) => { onFieldChange('other', e.target.value); autoResize(e.target); }}
        />
      </div>
    </div>
  );
}
